<template>
  <textarea
    class="form-input"
    v-bind="$attrs"
    :value="value"
    @input="event => $emit('update', event.target.value)"
    v-on="$listeners"
  >
  </textarea>
</template>

<script>
export default {
  name: 'TsTextArea',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'update'
  },
  props: ['value']
}
</script>
